	/*
	 *
	 *	$('#getCart').getUpdate({
	 *		getItem 	: '.setItem',
	 *		getQtty		: '.setQtty',
	 *		getSbtl		: '.setMath',
	 *		getTotal	: '.setTotal',
	 *		getItems 	: '.setCount'
	 *	 });
	 *
	 */

	;(function ( $, window, document, undefined ) {

		var pluginName = 'getUpdate',
			defaults = {
				propertyName: "value"
			};

		function Plugin( element, options ) {
			this.element = element;
			this.options = $.extend( {}, defaults, options );
			this._defaults = defaults;
			this._name = 'getUpdate';
			this.init();
		}

		Plugin.prototype = {
			init: function() {
				var getItem	 = this.options.getItem,
					getQtty	 = this.options.getQtty,
					getSbtl  = this.options.getSbtl,
					getTotal = $(this.options.getTotal),
					getItems = $(this.options.getItems);
				
				$(getQtty).change(function() {
					var setQty  = $(this).val(),
						setItem = $(this).closest(getItem),
						setCode = setItem.data('id'),
						setSbtl = setItem.find(getSbtl);

					$.ajax({
	                    type: 'POST',
	                    url: '/cart/change.js',
	                    dataType: 'json',
	                    data: {
	                        quantity: setQty,
	                        id: setCode
	                    },
						success: function(cart) {
							$.each(cart.items,function(index,row) {
								if ( setCode == row.variant_id ) setSbtl.html( '$' + parseFloat(row.line_price / 100).toFixed(2) );
							});
							getTotal.html( '$' + parseFloat(cart.total_price / 100).toFixed(2) );
							getItems.html(cart.item_count)
						},
						error: function(response) {
							console.log(response)
						}
					});
				});

				$(this.options.item_remove).click(function(e) {
					e.preventDefault();
					$(this).closest(getItem).find(getQtty).val(0);
					$(this).closest(getItem).find(getQtty).trigger('change');
				});

			}
		};

		$.fn.getUpdate = function ( options ) {
			return this.each(function () {
				if (!$.data(this, "plugin_" + pluginName)) {
					$.data(this, "plugin_" + pluginName, new Plugin( this, options ));
				}
			});
		};

	})( jQuery, window, document );